import { VariableType } from 'json-to-graphql-query';
import { EntityResource } from './entity.resource';
import { RoleInputVariables, RoleInputArgs } from './queryVariables/roleInput';
/**
 * Resource ról
 *
 * @export
 * @class RoleResource
 * @extends {EntityResource<RoleObjectType>}
 */
export class RoleResource extends EntityResource {
    constructor() {
        super({ entityName: 'role' });
        this.getFields = {
            id: true,
            name: true
        };
        this.listFields = {
            id: true,
            name: true,
            parent: {
                id: true,
                name: true
            }
        };
        this.listVariables = { filters: 'RoleFiltersInput' };
        this.addVariables = RoleInputVariables;
        this.addArgs = RoleInputArgs;
        this.updateVariables = { ...RoleInputVariables, id: 'Int!' };
        this.updateArgs = { ...RoleInputArgs, id: new VariableType('id') };
    }
    /**
     * Dodaje rolę do użytkownika
     *
     * @param {number} roleId
     * @param {string} userId
     * @returns {Promise<number>}
     * @memberof RoleResource
     */
    async userRoleAdd(roleId, userId, entityType, entityId) {
        const mutation = this.prepareOptions({
            mutation: {
                __variables: { roleId: 'Int!', userId: 'String!', entityType: 'String', entityId: 'String' },
                userRoleAdd: {
                    __args: {
                        roleId: new VariableType('roleId'),
                        userId: new VariableType('userId'),
                        entityType: new VariableType('entityType'),
                        entityId: new VariableType('entityId')
                    }
                }
            }
        });
        return this.mutation({
            mutation,
            variables: { roleId, userId, entityType, entityId }
        }, 'userRoleAdd');
    }
    /**
     * Usuwa rolę użytkownika
     *
     * @param {number} roleId
     * @param {string} userId
     * @returns {Promise<number>}
     * @memberof RoleResource
     */
    async userRoleDelete(roleId, userId, entityType, entityId) {
        const mutation = this.prepareOptions({
            mutation: {
                __variables: { roleId: 'Int!', userId: 'String!', entityType: 'String', entityId: 'String' },
                userRoleDelete: {
                    __args: {
                        roleId: new VariableType('roleId'),
                        userId: new VariableType('userId'),
                        entityType: new VariableType('entityType'),
                        entityId: new VariableType('entityId')
                    }
                }
            }
        });
        return this.mutation({
            mutation,
            variables: { roleId, userId, entityType, entityId }
        }, 'userRoleDelete');
    }
    /**
     * Pobiera liste ról użytkownika
     *
     * @param {string} userId
     * @returns {Promise<RoleObjectType[]>}
     * @memberof RoleResource
     */
    async userRoles(userId) {
        const query = this.prepareOptions({
            query: {
                __variables: { userId: 'String!' },
                userRoles: {
                    __args: { userId: new VariableType('userId') },
                    id: true
                }
            }
        });
        return this.query({
            query,
            variables: { userId }
        }, 'userRoles');
    }
}
export const roleResource = new RoleResource();
//# sourceMappingURL=role.resource.js.map